import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import AuthButton from './AuthButton';
import LanguageSelector from './LanguageSelector';
import SocialMediaCTAs from './SocialMediaCTAs';
import '../styles/app-header.css';

const AppHeader = ({
  currentFileName,
  osmdInstance,
  visibleParts,
  onTipsUpdated,
  onTipPlacementModeChange,
  onLoadFileRequest,
  onNewsUpdated,
  onRegisterTrigger
}) => {
  const { t } = useLanguage();
  return (
    <div className="app-header">
      <div className="app-header-content">
        <div className="app-title-section">
          <h1 className="app-title">
            {t('app.choirName')}
          </h1>
          <p className="app-subtitle">
            {t('app.platformSubtitle')}
          </p>
        </div>
        <div className="app-header-actions">
          <SocialMediaCTAs variant="header" />
          <AuthButton
            currentFileName={currentFileName}
            osmdInstance={osmdInstance}
            visibleParts={visibleParts}
            onTipsUpdated={onTipsUpdated}
            onTipPlacementModeChange={onTipPlacementModeChange}
            onLoadFileRequest={onLoadFileRequest}
            onNewsUpdated={onNewsUpdated}
            onRegisterTrigger={onRegisterTrigger}
          />
          <LanguageSelector />
        </div>
      </div>
    </div>
  );
};

export default AppHeader;